import { Container, Row, Col } from "react-bootstrap";
import TabMenu from "./TabMenu";
import PostsCustomer from "./PostCustomer/posts";
import { Outlet, useParams } from "react-router-dom";

const Tab4 = () => {
  const { Id } = useParams();

  return (
    <Container fluid className="dashboard">
      <Row className="g-4">
        <Col md={4} lg={3} className="p-2">
          <TabMenu />
        </Col>

        {/* Main Content */}
        <Col xs={12} md={8} lg={9}>
          {Id ? <Outlet /> : <PostsCustomer />}
        </Col>
      </Row>
    </Container>
  );
};

export default Tab4;
